import { SpecialtiesPage } from "./SpecialtiesPage";
export default SpecialtiesPage;
